"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluate = evaluate;
function evaluate(resultToEvaluate) {
    var _a;
    const status = (_a = resultToEvaluate === null || resultToEvaluate === void 0 ? void 0 : resultToEvaluate.data) === null || _a === void 0 ? void 0 : _a.status;
    return status === 'successful' || status === 'fail';
}
//# sourceMappingURL=CapabilityUpdateStatusEvaluator.js.map